<template>
  <v-dialog @input="close" :value="isOpened" max-width="900px">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title class="font-weight-bold">
          {{ $t('entities.taxJurisdictions.viewEntity') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-0 pb-0">
        <v-container>
          <v-card class="pa-4 mt-4">
            <div class="d-flex align-center justify-space-between w-100">
              <v-card-title class="pa-0 tax-jurisdiction-name">
                {{ taxJurisdiction.name }}
              </v-card-title>
              <p class="mb-0 text-right">#{{ taxJurisdiction.id }}</p>
            </div>
          </v-card>
          <v-card class="px-4 pb-4 mt-4">
            <div class="d-flex align-center justify-space-between pt-4 pb-2">
              <div class="text-h6">
                {{ $t('entities.taxJurisdictions.attributes.taxes') }}
              </div>
              <div class="subtitle-2 grey--text">
                {{ taxes.length }} {{ $t('miscellaneous.items') }}
              </div>
            </div>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ $t('entities.taxesV2.attributes.name') }}
                  </th>
                  <th class="text-left">
                    {{ $t('entities.taxesV2.attributes.invoiceLabel') }}
                  </th>
                  <th class="text-left">
                    {{ $t('entities.taxesV2.attributes.description') }}
                  </th>
                  <th class="text-right">
                    {{ $t('entities.taxesV2.attributes.rate') }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="taxes.length">
                <tr v-for="tax in taxes" :key="tax.id">
                  <td class="font-weight-bold">
                    {{ tax.name || '—' }}
                  </td>
                  <td>
                    {{ tax.invoice_label || '—' }}
                  </td>
                  <td>
                    {{ tax.description || '—' }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ tax.rate || '—' }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center grey--text" colspan="4">
                    {{ $t('components.noData.noEntriesFound') }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TaxJurisdictionDetailsDialog',
  props: {
    taxJurisdiction: { type: Object, default: () => ({}) },
    isOpened: { type: Boolean, required: true },
  },
  computed: {
    taxes() {
      return this.taxJurisdiction.taxes || []
    },
  },
  methods: {
    close() {
      return this.$emit('dialog:close')
    },
  },
}
</script>
